<div class="app-page">
  <div class="app-page-content">
    <section class="app-card">

      <!-- Header -->
      <header class="mb-6 flex flex-col gap-3 md:flex-row md:items-center md:justify-between">
        <div class="flex flex-col gap-1">
          <h1 class="section-title">Tarifas</h1>
          <p class="section-subtitle">
            Gestión de tarifas del sistema
          </p>
        </div>

        <div class="flex flex-wrap items-center gap-2">
          <span class="app-badge">
            <strong>{{ totalRecords() }}</strong> tarifas
          </span>
          <span
            class="app-badge"
            [ngClass]="{
              'app-badge-primary': !paginate
            }">
            {{ paginate ? 'Paginado' : 'Todos' }}
          </span>
        </div>
      </header>

    <p-confirmDialog [baseZIndex]="10000"></p-confirmDialog>

    <p-table
      #dt
      [value]="tarifas()"
      [columns]="columnsTable"
      dataKey="id"
      sortMode="multiple"
      [(selection)]="selectedRows"
      [loading]="loading()"
      [rowHover]="true"
      [lazy]="true"
      (onLazyLoad)="loadLazy($event)"
      styleClass="app-table-container"
      [paginator]="paginate"
      [rows]="nroFilasPorPagina"
      [totalRecords]="totalRecords()"
      [filterDelay]="500"
      [scrollable]="false"
      [globalFilterFields]="['codigo','nombre','descripcion']"
      currentPageReportTemplate="{first} - {last} de {totalRecords} registros"
      [showCurrentPageReport]="true"
      [rowsPerPageOptions]="rowsPerPageOptions"
      responsiveLayout="stack"
      [breakpoint]="'960px'">

      <!-- Toolbar Caption -->
      <ng-template pTemplate="caption">
        <div class="flex flex-col gap-4 py-2">
          <div class="flex flex-col gap-4 md:flex-row md:items-center md:justify-between">
            <!-- Search Input -->
            <div class="w-full md:max-w-96">
              <span class="p-input-icon-left w-full search-input-wrapper">
                <i class="pi pi-search search-icon"></i>
                <input
                  type="text"
                  pInputText
                  [(ngModel)]="filterValue"
                  (input)="dt.filterGlobal(filterValue, 'contains')"
                  placeholder="Buscar por código, nombre o descripción"
                  class="w-full"
                />
              </span>
            </div>

            <!-- Action Buttons -->
            <div class="flex flex-wrap items-center gap-2.5">
              <button
                pButton
                type="button"
                [label]="paginate ? 'Paginado' : 'Todos'"
                [icon]="paginate ? 'pi pi-lock' : 'pi pi-lock-open'"
                class="p-button-outlined p-button-sm"
                (click)="paginate = !paginate; cargar()">
              </button>
              <button
                pButton
                type="button"
                label="Limpiar"
                icon="pi pi-filter-slash"
                class="p-button-outlined p-button-sm"
                (click)="clear(dt)">
              </button>
              <button
                pButton
                type="button"
                label="Nueva tarifa"
                icon="pi pi-plus"
                class="p-button-sm"
                (click)="navigateToCreateTarifa()">
              </button>
            </div>
          </div>
        </div>
      </ng-template>

      <!-- Column Headers -->
      <ng-template pTemplate="header" let-columns>
        <tr>
          <th *ngFor="let col of columns"
              [pSortableColumn]="col.sortable ? col.field : ''"
              class="px-4 py-3.5 text-left text-xs font-semibold uppercase tracking-wide">
            <div class="flex items-center justify-between gap-2">
              <span>{{ col.header }}</span>
              <div class="flex items-center gap-2">
                <p-sortIcon *ngIf="col.sortable" [field]="col.field"></p-sortIcon>
                <p-columnFilter
                  *ngIf="col.filtrable"
                  [type]="getFilterType(col)"
                  [field]="col.field"
                  [display]="col.modeDisplayFilter || 'menu'"
                  [showMatchModes]="false"
                  [matchMode]="getMatchMode(col.fieldType)"
                  [showOperator]="false"
                  [showAddButton]="false">
                </p-columnFilter>
              </div>
            </div>
          </th>
        </tr>
      </ng-template>

      <!-- Table Body -->
      <ng-template pTemplate="body" let-tarifa let-columns="columns">
        <tr class="transition-colors">
          <td *ngFor="let col of columns" [ngSwitch]="col.field" class="px-4 py-4">

            <!-- Campo Código -->
            <div *ngSwitchCase="'codigo'">
              <span class="text-sm font-medium" style="color: hsl(var(--text));">
                {{ tarifa.codigo || '-' }}
              </span>
            </div>

            <!-- Campo Nombre -->
            <div *ngSwitchCase="'nombre'">
              <span class="text-sm" style="color: hsl(var(--text));">
                {{ tarifa.nombre || '-' }}
              </span>
            </div>

            <!-- Campo Descripción -->
            <div *ngSwitchCase="'descripcion'">
              <span class="text-sm text-muted">
                {{ tarifa.descripcion || '-' }}
              </span>
            </div>

            <!-- Campo Vigencia Desde -->
            <div *ngSwitchCase="'vigenciaDesde'">
              <span class="text-sm text-muted">
                {{ formatDate(tarifa.vigenciaDesde) }}
              </span>
            </div>

            <!-- Campo Vigencia Hasta -->
            <div *ngSwitchCase="'vigenciaHasta'">
              <span class="text-sm text-muted">
                {{ formatDate(tarifa.vigenciaHasta) }}
              </span>
            </div>

            <!-- Campo Activa -->
            <div *ngSwitchCase="'active'" class="flex items-center gap-2">
              <i
                [class]="tarifa.active ? 'pi pi-check-circle' : 'pi pi-times-circle'"
                [style.color]="tarifa.active ? 'hsl(var(--success))' : 'hsl(var(--error))'"
                class="text-lg"
                [pTooltip]="tarifa.active ? 'Activa' : 'Inactive'"
                tooltipPosition="top">
              </i>
              <span class="text-sm" [style.color]="tarifa.active ? 'hsl(var(--success))' : 'hsl(var(--error))'">
                {{ tarifa.active ? 'Activa' : 'Inactive' }}
              </span>
            </div>

            <!-- Campo Acción -->
            <div *ngSwitchCase="'accion'" class="flex items-center gap-2">
              <button
                pButton
                type="button"
                icon="pi pi-pencil"
                class="p-button-rounded p-button-text p-button-sm"
                pTooltip="Editar"
                tooltipPosition="top"
                (click)="editarTarifa(tarifa.id!)">
              </button>
              <button
                *ngIf="tarifa.active"
                pButton
                type="button"
                icon="pi pi-trash"
                class="p-button-rounded p-button-text p-button-sm p-button-danger"
                pTooltip="Desactiver tarifa"
                tooltipPosition="top"
                (click)="eliminarTarifa(tarifa)">
              </button>
              <button
                *ngIf="!tarifa.active"
                pButton
                type="button"
                icon="pi pi-check"
                class="p-button-rounded p-button-text p-button-sm p-button-success"
                pTooltip="Activar tarifa"
                tooltipPosition="top"
                (click)="activerTarifa(tarifa)">
              </button>
            </div>

            <!-- Campos por defecto -->
            <div *ngSwitchDefault>
              <span class="text-sm text-muted">
                {{ tarifa[col.field] || '-' }}
              </span>
            </div>
          </td>
        </tr>
      </ng-template>

      <!-- Empty Message -->
      <ng-template pTemplate="emptymessage">
        <tr>
          <td [attr.colspan]="columnsTable.length" class="text-center py-8">
            <div class="flex flex-col items-center gap-3">
              <i class="pi pi-inbox text-5xl text-muted"></i>
              <p class="text-muted">No se encontraron tarifas</p>
            </div>
          </td>
        </tr>
      </ng-template>

      <!-- Loading Template -->
      <ng-template pTemplate="loadingbody">
        <tr>
          <td [attr.colspan]="columnsTable.length">
            <div class="flex items-center justify-center py-8">
              <i class="pi pi-spin pi-spinner text-3xl" style="color: hsl(var(--primary));"></i>
            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>
    </section>
  </div>
</div>
